function replaceUrlParam(url, paramName, paramValue) {
    if (paramValue == null) {
        paramValue = '';
    }
    var pattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');
    if (url.search(pattern) >= 0) {
        return url.replace(pattern, '$1' + paramValue + '$2');
    }
    url = url.replace(/[?#]$/, '');
    return url + (url.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
}

(function ($) {
    "use strict";
    $(function () {

        $.getUrlParameter = function getUrlParameter(sParam) {
            var sPageURL = decodeURIComponent(window.location.search.substring(1)),
                sURLVariables = sPageURL.split('&'),
                sParameterName,
                i;

            for (i = 0; i < sURLVariables.length; i++) {
                sParameterName = sURLVariables[i].split('=');

                if (sParameterName[0] === sParam) {
                    return sParameterName[1] === undefined ? true : sParameterName[1];
                }
            }
        };

        var block_submit_twice = false;

        if ($('.template--archive-nominee').length) {
            if ($.getUrlParameter('o') != undefined || $.getUrlParameter('c') != undefined) {
                $('html, body').animate({ scrollTop: $('.js-nominees-to-scroll').offset().top - $('header').outerHeight() }, 700);
            }
        }

        $('.js-change-tab').on('click', function (e) {
            e.preventDefault();
            var $id = $(this).data('id');
            $('.js-change-tab.active').removeClass('active');
            $(this).addClass('active');
            $('.tab-pane.active').removeClass('active');
            $(`#${$id}`).addClass('active')
            var newUrl = replaceUrlParam(window.location.href, 'c', $id);

            history.pushState({}, null, newUrl);
        });

        $('.js-category-select').on('change', function (e) {
            e.preventDefault();
            var $id = $(this).val();
            $('.js-change-tab.active').removeClass('active');
            $(`.js-change-tab[data-id=${$id}]`).addClass('active');
            $('.tab-pane.active').removeClass('active');
            $(`#${$id}`).addClass('active')
            var newUrl = replaceUrlParam(window.location.href, 'c', $id);

            history.pushState({}, null, newUrl);
        })


        $('.js-order-select').SumoSelect({ search: false, placeholder: 'Rendezés' });


        $('.js-category-select').SumoSelect({ search: false });


        $(document).on("click", ".js-load-more", function () {
            const page = $(this).data("page");
            const maxPages = $(this).data("max");
            const type = $(this).data("type");
            const newPage = page + 1;
            const urlParams = $.getUrlParameter('o');
            const order = (urlParams != undefined) ? urlParams : "rand";


            if (block_submit_twice) {
                return false;
            }

            block_submit_twice = true;

            if (maxPages >= newPage) {

                $.ajax({
                    url: localize.ajaxurl,
                    type: "POST",
                    data: {
                        page: page,
                        type: type,
                        o: order,
                        action: "load_more"
                    },
                    error: function (response) {
                        console.log(response);
                    },
                    success: function (response) {
                        block_submit_twice = false;

                        $('.js-load-more[data-type="' + type + '"]').data("page", newPage);

                        $(".js-load-" + type).append(response).promise().done(function (e) {
                            $('[data-mh]').matchHeight({ remove: true });
                            $.fn.matchHeight._maintainScroll = true;
                            $.fn.matchHeight._applyDataApi();
                        });

                        if (maxPages === newPage) {
                            $('.js-load-more[data-type="' + type + '"]').addClass("button--disabled");
                            $('.js-load-more[data-type="' + type + '"]').css("pointer-events", "none");
                        }
                    }
                });
            } else {
                block_submit_twice = false;

                $('.js-load-more[data-type="' + type + '"]').addClass("button--disabled");
                $('.js-load-more[data-type="' + type + '"]').css("pointer-events", "none");
            }
        });

    });
})(jQuery);
